import type { GetNotifications200NotificationsItemBasicInfo } from './getNotifications200NotificationsItemBasicInfo';
import type { GetNotifications200NotificationsItemData } from './getNotifications200NotificationsItemData';
import type { GetNotifications200NotificationsItemSource } from './getNotifications200NotificationsItemSource';
import type { GetNotifications200NotificationsItemStatus } from './getNotifications200NotificationsItemStatus';
import type { GetNotifications200NotificationsItemTarget } from './getNotifications200NotificationsItemTarget';

export type GetNotifications200NotificationsItem = {
  basicInfo: GetNotifications200NotificationsItemBasicInfo;
  /** @nullable */
  data?: GetNotifications200NotificationsItemData;
  source?: GetNotifications200NotificationsItemSource;
  status: GetNotifications200NotificationsItemStatus;
  target?: GetNotifications200NotificationsItemTarget;
};
